/**
 * ユニオン型にstring型が含まれる引数をstring判定する
 * @param data 対象の引数
 * @returns string型:true
 */
export const isString = (data: unknown): data is string => {
  return typeof data === "string";
};
